import styled from 'styled-components';

export const GridLayout = styled.div`
  display: grid;
  grid-template-columns: 100px 500px;
  column-gap: 24px;
`;

export const Grid1 = styled.div`
  grid-column: 1 / 2;
  margin-top: 8px;
`;

export const Grid2 = styled.div`
  grid-column: 2 / 3;
`;